<template>
	<div>
		<sky-card :title="'联系人信息'" >
			<!-- <div slot="header-btns" @click="add" class="del-btn">添加</div> -->
			<div class="card-content" v-if="contactlist.length > 0" ref="box">
				<div class="sub-title">
					<span>联系人({{ contactlist.length }})</span>
				</div>
				<div v-for="(item, index) in contactlist" :key="item.id" class="container">
					<div>
						<div class="info16" v-if="item.aiFlag == 1">
							<ig-icon name="fluorescent"></ig-icon>此数据由AI大数据洞察引擎提供
						</div>
						<div class="content">
							<div class="form">
								<!-- <clueContactForm
									v-if="showEdit == index"
									:summaryId="summaryId"
									:attributes="item"
									@cancel="cancel(item.id, index)"
									@submit="data => update(data, item)"
								></clueContactForm> -->
							</div>
							<div v-show="showEdit != index">
								<el-row type="flex">
									<el-col class="label1 avatar">
										<el-avatar
											:src="item.iconPath"
											:icon="item.iconPath ? '' : 'el-icon-user-solid'"
											:size="50"
											fit="fill"
										></el-avatar>
									</el-col>
									<el-col class="value1 social_icon">
										<div v-for="sns in filterSns(item.contactSns)" :key="sns.id">
											<ig-icon
												name="Facebook"
												v-if="
													(sns.snsName === 'facebook' || sns.snsName === 'Facebook') &&
													urlJudge(sns.snsContent)
												"
												style="color: #3b5998"
												class="icon-base"
												@click.native="open(sns.snsContent)"
											></ig-icon>
											<ig-icon
												name="twitter"
												v-if="
													(sns.snsName === 'twitter' || sns.snsName === 'Twitter') &&
													urlJudge(sns.snsContent)
												"
												style="color: #0077b5"
												class="icon-base"
												@click.native="open(sns.snsContent)"
											></ig-icon>
											<ig-icon
												name="LinkedIn"
												v-if="
													(sns.snsName === 'linkedin' || sns.snsName === 'Linkedin') &&
													urlJudge(sns.snsContent)
												"
												style="color: #0077b5"
												class="icon-base"
												@click.native="open(sns.snsContent)"
											></ig-icon>
										</div>
									</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">联系人名称</el-col>
									<el-col class="value1">
										{{ item.contactName }}
										<ig-icon name="bianji2" class="blue" @click.native="edit(index)"></ig-icon>
									</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">联系电话</el-col>
									<el-col class="value1" v-if="item.phone.length">{{
										item.phone | phoneFilters
									}}</el-col>
									<el-col class="value1" v-else>-</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">邮箱</el-col>
									<el-col class="value1">{{ item.email || '-' }}</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">职位</el-col>
									<el-col class="value1">{{ item.contactJob || '-' }}</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">性别</el-col>
									<el-col class="value1">{{ item.sex | textFilters }}</el-col>
								</el-row>
								<el-row type="flex" v-for="(ele, index) in item.contactSns" :key="index">
									<el-col class="label1">{{ ele.snsName || 'SNS' }} </el-col>
									<el-col class="value1">{{ ele.snsContent || '-' }}</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">备注</el-col>
									<el-col class="value1">{{ item.remark || '-' }}</el-col>
								</el-row>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="no-content">暂无数据</div>
		</sky-card>
	</div>
</template>
<script>
import chatSer from '@/backend/services/chat/chatSer.js';
// import addressList from '@/client/services/addressList/addressList.js';
// import clueContactForm from '@/components/iglobalwin/form-warps/clueContactForm.vue';
import skyCard from '@/components/iglobalwin/sky-card.vue';

import { mapGetters } from 'vuex';
export default {
	props: {
		summaryId: {
			type: String,
		},
		companyDataInfo: {
			type: Object,
		},
	},
	data() {
		return {
			editVisible: false,
			showEdit: -1,
			contactlist:[],
		};
	},
	filters: {
		textFilters(val) {
			if (String(val) === '0') {
				return '女';
			} else if (val == 1) {
				return '男';
			} else {
				return '-';
			}
		},
		phoneFilters(val) {
			if (Array.isArray(val)) {
				return val.join(',');
			} else {
				return '-';
			}
		},
	},
	// computed: {
	// 	...mapGetters(['contactlist']),
	// },
	watch: {

		summaryId: {
			handler(val) {
				if (val) {
					this.getContactList();
				}
			},
			immediate: true,
		},
	},
	methods: {
		async getContactList() {
			//联系人列表
			const resContact = await chatSer.getContactlist({ id: this.summaryId ,type:1});
			if (resContact.data) {
				this.contactlist=resContact.data;
			}
		},
		edit(index) {
			this.showEdit = index;
		},
		// async update(data, _item) {
		// 	let { id, type } = _item;
		// 	let { summaryId } = this;
		// 	let res;
		// 	data.contactSns = data.contactSns.filter(item => {
		// 		delete item.id;
		// 		return item.snsContent !== '' && item.snsName !== '';
		// 	});
		// 	data.phone = data.phone.filter(item => {
		// 		return item;
		// 	});
		// 	try {
		// 		if (id) {
		// 			if (type) {
		// 				let { phone: phoneList, contactSns: snsList } = data;
		// 				delete data.phone;
		// 				delete data.contactSns;
		// 				let params = {
		// 					...data,
		// 					phoneList,
		// 					snsList,
		// 				};
		// 				res = await addressList.editAddressBook(params, { id });
		// 			} else {
		// 				let { phone, email } = data;
		// 				if (phone.length === 0 && !email) {
		// 					this.$message.warning('请填写联系电话或邮箱');
		// 					return;
		// 				}
		// 				res = await clueSer.updateContact({
		// 					id,
		// 					summaryId,
		// 					...data,
		// 				});
		// 			}
		// 		} else {
		// 			let { phone, email } = data;
		// 			if (phone.length === 0 && !email) {
		// 				this.$message.warning('请填写联系电话或邮箱');
		// 				return;
		// 			}
		// 			res = await clueSer.addContact({
		// 				summaryId,
		// 				...data,
		// 			});
		// 		}
		// 		if (res) {
		// 			this.showEdit = -1;
		// 			this.$emit('getList');
		// 		}
		// 	} catch (error) {}
		// },
		cancel(id, index) {
			this.showEdit = -1;
			if (!id) {
				this.contactlist.splice(index, 1);
			}
		},
		add() {
			if (this.showEdit == -1) {
				this.contactlist.unshift({
					contactJob: '',
					contactName: '',
					email: '',
					id: '',
					item: '',
					line: '',
					massage: '',
					phone: '',
					sex: '',
					sns: '',
					wechat: '',
					whatsApp: '',
				});

				this.showEdit = 0;
			}
		},
		// 打开链接
		open(value) {
			// window.open(value)
			var oA = document.createElement('a'); //创建a标签
			oA.href = value; //添加 href 属性
			oA.target = '_blank'; //添加 target 属性
			oA.click(); //模拟点击
		},
		// 链接判断
		urlJudge(url) {
			var reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
			return reg.test(url);
		},
		// 过滤sns
		filterSns(list = []) {
			let arr = [];
			let listCopy = [];
			list.forEach(sns => {
				if (
					(sns.snsName === 'twitter' || sns.snsName === 'Twitter') &&
					this.urlJudge(sns.snsContent)
				) {
					if (arr.includes('Twitter')) return;
					arr.push('Twitter');
					listCopy.push(sns);
					return;
				}
				if (
					(sns.snsName === 'facebook' || sns.snsName === 'Facebook') &&
					this.urlJudge(sns.snsContent)
				) {
					if (arr.includes('Facebook')) return;
					arr.push('Facebook');
					listCopy.push(sns);
					return;
				}
				if (
					(sns.snsName === 'linkedin' || sns.snsName === 'Linkedin') &&
					this.urlJudge(sns.snsContent)
				) {
					if (arr.includes('Linkedin')) return;
					arr.push('Linkedin');
					listCopy.push(sns);
					return;
				}
			});
			return listCopy;
		},
	},
	components: {
		//  clueContactForm,
		 skyCard },
};
</script>
<style lang="scss" scoped>
.info16 {
	overflow-wrap: break-word;
	color: rgba(255, 188, 49, 1);
	font-size: 14px;
	font-weight: 600;
	font-family: PingFangSC-Regular;
	white-space: nowrap;
	line-height: 20px;
}
.card-content {
	padding-bottom: 40px;
}

.container {
	width: 100%;
	padding: 0 30px;
	margin-top: 20px;
}

.content {
	width: 100%;
	padding: 15px 20px;
	background: #f8f9fc;
	border-radius: 4px;
}

.label1 {
	width: 110px !important;
	padding: 5px 0;
	text-align: right;
}

.value1 {
	padding: 5px 12px;
	color: #333;
	word-break: break-all;
	text-align: left;
	display: inline-block;
	word-wrap: break-word;
	.icon-base {
		font-size: 22px;
		margin-right: 10px;
		cursor: pointer;
	}
}

.social_icon {
	display: flex;
	align-items: center;
}

.blue {
	color: #3da1ff;
	margin-left: 5px;
	cursor: pointer;
}

.del-btn {
	color: #3da1ff;
	float: right;
	cursor: pointer;
}

.sub-title {
	width: 100%;
	margin: 20px 30px;
}

.no-content {
	text-align: center;
	height: 50px;
	color: #999;
}

.avatar {
	::v-deep  .el-avatar {
		img {
			width: 100%;
		}
	}
}
</style>
